module.exports = __webpack_public_path__ + "img/2019poster.01337d60.jpg";